export default "__VITE_ASSET__jfq9Q$mG__"